import {
  Inserter,
  Wrapper,
  SessionRole,
  PartMenu,
  DragAndDropContext,
  ExtensionView,
  useLocation,
} from "nystem-components";
import "./index.css";
import ErrorBoundary from "./errorBoundary.js";

const Index = () => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary>
      <ExtensionView type="background">
        <SessionRole userrole="logged-in">
          <Inserter source="/denon/extension/upstairs" />
        </SessionRole>
      </ExtensionView>
      <ExtensionView type="popup web">
        <DragAndDropContext>
          <SessionRole userrole="logged-out" className="remotor-pages">
            <PartMenu />
            <Inserter
              source="/adminUser/login"
              className="mt-12 max-w-xl px-2 pt-4 pb-4 text-gray-100 sm:pb-6"
              match="*"
            />
          </SessionRole>
          <SessionRole
            userrole="logged-in"
            className={[
              navigator.remotor && "remotor-iphone",
              pathname === "/" ||
              pathname === "/popup.html" ||
              pathname.startsWith("/event/front") ||
              pathname.startsWith("/event/fullfront")
                ? "text-base"
                : "remotor-pages text-base",
            ]}
          >
            <PartMenu />
            <Wrapper renderAs="main" className="mt-12 max-w-xl px-2 pt-3 pb-4 text-gray-100 empty:hidden sm:pb-6">
              <Inserter match="/" source="/event/frontAll" />
              <Inserter match="/popup.html" source="/event/frontAll" />
              <Inserter match="/remotorapp/*" source="/device/backlights" />
              <Inserter match="/denon/*" />
              <Inserter match="/energy/*" />
              <Inserter match="/energyRecording/*" />
              <Inserter match="/adminUser/*" />
              <Inserter match={["/event/front*", "/event/fullfront*"]} />
              <Inserter match="/touchscreen/*" />
              <Inserter
                match={[
                  "/device/input*",
                  "/device/view/*",
                  "/device/backlights*",
                  "/device/temperature/*",
                  "/device/brushing/*",
                  "/device/weight/*",
                  "/device/weighing/*",
                ]}
              />
              <Inserter match="/weighing/*" />
              <Inserter match="/roborock/*" />
              <Inserter match="/unit/input*" />
              <Inserter match="/remotorapp/*" />
              <Inserter match="/menuItem/*" />
              <Inserter match="/driveSync/*" />
              <Inserter match="/driveActivity/*" />
              <Inserter match="/computer/*" />
            </Wrapper>
            <Inserter
              match={[
                "/event/input*",
                "/event/list*",
                "/device/list*",
                "/device/overview*",
                "/schedule/*",
                "/unit/list*",
              ]}
              className="mt-12 px-2 pt-4 pb-4 text-gray-100 sm:pb-6"
            />
            <Inserter
              match={[
                "/admin",
                "/device/settings",
                "/velux/*",
                "/homey/*",
                "/homeyAutomation/*",
                "/hueLampStates/*",
                "/zigbee/*",
                "/bluetooth/*",
                "/bluetoothProfile/*",
                "/bluetoothDevice/*",
                "/xiaomi/*",
              ]}
            >
              <Wrapper className="mt-12 max-w-5xl text-gray-100 md:flex md:gap-4 md:px-2 md:pt-3">
                <Inserter
                  match="*"
                  source="/admin/menu"
                  className="flex gap-1 overflow-x-auto border-b border-gray-800 px-2 py-2 md:block md:w-52 md:shrink-0 md:space-y-1 md:border-0 md:p-0"
                />
                <Wrapper className="min-w-0 grow px-2 pt-3 pb-6 md:pt-0">
                  <Inserter match={["/admin", "/device/settings"]} source="/velux/list" />
                  <Inserter match="/velux/*" />
                  <Inserter match="/homey/*" />
                  <Inserter match="/homeyAutomation/*" />
                  <Inserter match="/hueLampStates/*" />
                  <Inserter match="/zigbee/*" />
                  <Inserter match="/bluetooth/*" />
                  <Inserter match="/bluetoothProfile/*" />
                  <Inserter match="/bluetoothDevice/*" />
                  <Inserter match="/xiaomi/*" />
                </Wrapper>
              </Wrapper>
            </Inserter>
          </SessionRole>
        </DragAndDropContext>
      </ExtensionView>
    </ErrorBoundary>
  );
};

export default Index;
